<!-- @format -->

<template>
	<el-collapse class="el-card">
		<slot></slot>
	</el-collapse>
</template>

<script setup lang="ts"></script>

<style scoped></style>
